import { selectBrand, useAppSelector } from '@open-tender/cloud'
import { ModalView } from 'components'
import LoginEmail from './LoginEmail'
import LoginOTP from './LoginOTP'

const Login = ({
  callback,
  isForgotPassword = false,
  requiredEmail,
}: {
  callback?: () => void
  isForgotPassword?: boolean
  requiredEmail?: string
}) => {
  const { tpls } = useAppSelector(selectBrand) || {}

  return (
    <ModalView>
      {tpls === 'COMO' ? (
        <LoginOTP callback={callback} />
      ) : (
        <LoginEmail
          callback={callback}
          isForgotPassword={isForgotPassword}
          requiredEmail={requiredEmail}
        />
      )}
    </ModalView>
  )
}

export default Login
